export const MAX_CHARGEBACK_DOCUMENT_SIZE_BR = import.meta.env
  .VITE_MAX_CHARGEBACK_DOCUMENT_SIZE_BR
  ? Number(import.meta.env.VITE_MAX_CHARGEBACK_DOCUMENT_SIZE_BR)
  : 10_485_760; // 10MB in bytes (10 * 1024 * 1024)

export const VALID_FILE_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'application/pdf',
] as const;

export const DEFAULT_IMAGE_ACCEPT = VALID_FILE_TYPES.join(',');
